// extracted by mini-css-extract-plugin
module.exports = {"containerRoot":"styles_containerRoot__i_G2a","containerLoadingPlaceholderItem":"styles_containerLoadingPlaceholderItem__Pe6nB"};